import React from 'react';

declare global {
	interface Window {
		__RENDERER_BYPASS_COVER_PICTURE_BREAKOUT_SSR__?: boolean;
	}
}

/**
 * Inline Script that updates breakout node width on client side,
 * before main JavaScript bundle is ready.
 *
 * More info: https://product-fabric.atlassian.net/wiki/spaces/E/pages/1216218119/Renderer+SSR+for+Breakout+Nodes
 */
export function CoverPictureAndButtonScript({
	shouldEnableInlineScript,
}: {
	shouldEnableInlineScript: boolean;
}) {
	/**
	 * Should only inline this script while SSR,
	 * not needed on the client side.
	 */
	// For hydrateRoot there is a mismatch on client for this script.
	// So we want to add the script on client side but guard it with check to
	// not execute logic
	if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
		if (shouldEnableInlineScript) {
			window.__RENDERER_BYPASS_COVER_PICTURE_BREAKOUT_SSR__ = true;
		} else {
			return null;
		}
	}
	const context = createBreakoutInlineScript();
	return (
		<script
			// To investigate if we can replace this.
			// eslint-disable-next-line react/no-danger
			dangerouslySetInnerHTML={{ __html: context }}
		/>
	);
}

export function createBreakoutInlineScript() {
	return `
  (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_COVER_PICTURE_BREAKOUT_SSR__) {
			return;
		}
		(${applyBreakoutAfterSSR.toString()})()
  })(window);
 `;
}

export function applyBreakoutAfterSSR() {
	const COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO = 38 / 7;
	const MIN_DYNAMIC_COVER_IMAGE_HEIGHT = 140;
	const MAX_DYNAMIC_COVER_IMAGE_HEIGHT = 750;

	const editorParent = document.querySelector('.fabric-editor-popup-scroll-parent');
	const parentWidth = editorParent?.clientWidth || 0;
	if (!parentWidth) {
		return;
	}

	let parentHeight = 0;
	const imgHeight = Math.floor(parentWidth / COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO);
	if (imgHeight < MIN_DYNAMIC_COVER_IMAGE_HEIGHT) {
		parentHeight = MIN_DYNAMIC_COVER_IMAGE_HEIGHT;
	} else if (imgHeight >= MAX_DYNAMIC_COVER_IMAGE_HEIGHT) {
		parentHeight = MAX_DYNAMIC_COVER_IMAGE_HEIGHT;
	} else {
		parentHeight = imgHeight;
	}

	const coverPicAndButtonWrapper = document.querySelector(
		'[data-id="cover-pic-and-button-wrapper"]',
	);
	const coverPictureWrapper = document.querySelector('[data-testid="cover-picture-wrapper"]');
	const hoverOverlayCustomSites = document.querySelector(
		'[data-testid="hover-overlay-custom-sites"]',
	);
	const actualCoverPicture = document.querySelector('[id="actual-cover-picture"]');

	if (
		!coverPictureWrapper ||
		!coverPicAndButtonWrapper ||
		!hoverOverlayCustomSites ||
		!actualCoverPicture
	) {
		return;
	}
	(coverPicAndButtonWrapper as HTMLElement).style.height = `${parentHeight}px`;
	(coverPictureWrapper as HTMLElement).style.width = `${parentWidth}px`;
	(hoverOverlayCustomSites as HTMLElement).style.height = `${parentHeight}px`;
	(actualCoverPicture as HTMLElement).style.height = `${parentHeight}px`;
}
